export const stringProps = [
    {
        table: 'general-information',
        tableKey: 'property-name',
        key: 'NAME',
        fromProps: true
    },
    {
        table: 'general-information',
        tableKey: 'address',
        key: 'ADDRESS',
        fromProps: true
    },
    {
        table: 'general-information',
        tableKey: 'city',
        key: 'CITY',
        fromProps: true
    },
    {
        table: 'general-information',
        tableKey: 'state',
        key: 'STATE',
        fromProps: true
    },
    {
        table: 'general-information',
        tableKey: 'zip',
        key: 'ZIP',
        fromProps: true
    },
    {
        table: 'general-information',
        tableKey: 'market',
        key: 'MARKET',
        fromProps: true
    },
    {
        table: 'general-information',
        tableKey: 'property-category',
        key: 'CATEGORY',
        fromProps: true
    },
    {
        table: 'general-information',
        tableKey: 'property-type',
        key: 'TYPE',
        fromProps: true
    },
    {
        table: 'general-information',
        tableKey: 'google-maps-link',
        key: 'CAD_LINK'
    },
    {
        table: 'general-information',
        tableKey: 'sale-lease-back',
        key: 'SALE_LEASE_BACK',
        defaultValue: 'No',
    },
    {
        table: 'offering-summary',
        tableKey: 'year-built',
        key: 'YEAR_BUILT',
        fromProps: true
    },
    {
        table: 'lease-summary',
        tableKey: 'lease-type',
        key: 'LEASE_TYPE',
        fromProps: true
    },
    {
        table: 'lease-summary',
        tableKey: 'increases',
        key: 'INCREASES'
    },
    {
        table: 'lease-summary',
        tableKey: 'guarantor',
        key: 'GUARANTOR',
    },
    {
        table: 'lease-summary',
        tableKey: 'options',
        key: 'OPTIONS'
    },
    {
        table: 'lease-summary',
        tableKey: 'options-to-purchase',
        key: 'OPTIONS_TO_PURCHASE'
    },
    {
        table: 'lease-notes',
        tableKey: 'lease-notes',
        key: 'LEASE_NOTES'
    }, 
    {
        table: 'offering-summary',
        tableKey: 'office-to-warehouse',
        key: 'OFFICE_TO_WAREHOUSE'
    },
    {
        table: 'offering-summary',
        tableKey: 'doors',
        key: 'DOORS'
    }
];

export const dateProps = [
    {
        table: 'general-information',
        tableKey: 'analysis-date',
        key: 'ANALYSIS_DATE',
        forceStatic: false
    },
    {
        table: 'lease-summary',
        tableKey: 'lease-commencement',
        key: 'LEASE_COMMENCEMENT_DATE',
        fromProps: true
    },
    {
        table: 'lease-summary',
        tableKey: 'lease-expiration',
        key: 'LEASE_EXPIRATION_DATE',
        fromProps: true
    }
];

export const numberProps = [
    {
        table: 'general-information',
        tableKey: 'appraised-value',
        key: 'APPRAISED_VALUE'
    },
    {
        table: 'offering-summary',
        tableKey: 'cap-rate',
        key: 'CAPITALIZATION_RATE',
        withReplace: true,
        fromProps: true,
        forceStatic: false
    },
    {
        table: 'offering-summary',
        tableKey: 'price-psf',
        key: 'PRICE_PSF',
        withReplace: true,
        withToFixed: true,
        forceStatic: false
    },
    {
        table: 'offering-summary',
        tableKey: 'gross-leasable-area',
        key: 'SQFT',
        withReplace: true,
        fromProps: true
    },
    {
        table: 'offering-summary',
        tableKey: 'lot-size',
        key: 'LOT_SIZE'
    },
    {
        table: 'lease-summary',
        tableKey: 'original-lease-term',
        key: 'ORIGINAL_LEASE_TERM',
    },
    {
        table: 'pricing-matrix',
        valueCellIndex: 0,
        tableKey: 'bps-change',
        key: 'PRICING_RANGE_BPS_CHANGE',
        forceStatic: false
    },
    {
        table: 'pricing-matrix',
        valueCellIndex: 0,
        tableKey: 'price-psf-change',
        key: 'PRICING_RANGE_PRICE_PSF_CHANGE',
        defaultValue: 5,
        withToFixed: true,
        forceStatic: false
    },
    {
        table: 'pricing-matrix-annex',
        valueCellIndex: 0,
        tableKey: 'down-payment',
        key: 'LOAN_INFO_DOWN_PAYMENT',
        defaultValue: 30,
        forceStatic: false
    },
    {
        table: 'pricing-matrix-annex',
        valueCellIndex: 1,
        tableKey: 'interest-rate',
        key: 'LOAN_INFO_INTEREST_RATE',
        withToFixed: true,
        defaultValue: 4.25,
        forceStatic: false
    },
    {
        table: 'pricing-matrix-annex',
        valueCellIndex: 1,
        tableKey: 'amortization',
        key: 'LOAN_INFO_AMORTIZATION',
        defaultValue: 25,
        forceStatic: false
    },
    {
        table: 'pricing-rent-matrix',
        tableKey: 'sqft',
        key: 'SQFT',
        valueCellIndex: 0,
        forceStatic:false,
    },
    {
        table: 'pricing-rent-matrix',
        valueCellIndex: 0,
        tableKey: 'rent-adjustment',
        key: 'PRICING_RANGE_PRICE_PSF_CHANGE',
        defaultValue: 5,
        withToFixed: true,
        forceStatic: false
    },
    {
        table: 'pricing-rent-matrix',
        tableKey: 'base-rent-psf',
        key: 'CAPITALIZATION_RATE',
        valueCellIndex: 6,
        forceStatic: false
    },
    {
        table: 'pricing-rent-matrix',
        tableKey: 'price-percentages',
        key: 'CAPITALIZATION_RATE',
        valueCellIndex: 3,
        forceStatic: false
    },
    {
        table: 'pricing-rent-matrix',
        valueCellIndex: 6,
        tableKey: 'rent-adjustment',
        key: 'PRICING_RANGE_BPS_CHANGE',
        forceStatic: false
    }, 
    {
        table: 'offering-summary',
        tableKey: 'clear-height',
        key: 'CLEAR_HEIGHT'
    }
];

export const vacantChanges = [  {
    table: 'offering-summary',
    rowKey: 'price',
    property: 'tooltip',
    getValue(isVacantLeaseType) {
        return isVacantLeaseType ? '= ROUNDUP(gross_leasable_area * price_psf / 5000) * 5000' : '= ROUNDUP(net_operating_income / cap_rate / 5000) * 5000';
    }
},{
    table: 'pricing-matrix',
    rowKey: 'bps-change',
    property: 'hidden',
    getValue(isVacantLeaseType) {
        return isVacantLeaseType;
    }
}, {
    table: 'pricing-matrix',
    rowKey: 'price-psf-change',
    property: 'hidden',
    getValue(isVacantLeaseType) {
        return !isVacantLeaseType;
    }
}, {
    table: 'pricing-matrix',
    rowKey: 'value',
    property: 'tooltip',
    hasValueCells: true,
    getValue(isVacantLeaseType) {
        return isVacantLeaseType ? '= ROUNDUP(gross_leasable_area * price_psf / 5000) * 5000' : '= ROUNDUP(net_operating_income / cap_rate / 5000) * 5000';
    }
}];

export const leaseChanges = [{
    table: 'lease-summary',
    rowKey: 'original-lease-term',
    property: 'editable',
    getValue(isSaleLeaseBack) {
        return isSaleLeaseBack;
    }
}, {
    table: 'lease-summary',
    rowKey: 'original-lease-term',
    property: 'tooltip',
    getValue(isSaleLeaseBack) {
        return isSaleLeaseBack ? '' : '= lease_expiration - lease_commencement';
    }
}, {
    table: 'lease-summary',
    rowKey: 'lease-commencement',
    property: 'editable',
    getValue(isSaleLeaseBack) {
        return !isSaleLeaseBack;
    }
}, {
    table: 'lease-summary',
    rowKey: 'lease-expiration',
    property: 'editable',
    getValue(isSaleLeaseBack) {
        return !isSaleLeaseBack;
    }
}];